import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Innovating for a Greener Future | Federico Marques</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>Things are only warming up in the new season of Technology for a Change. For our latest episode, we invited Federico Marques, founder and CEO of Moonflower Farms - the largest indoor vertical farm in Houston. Federico discussed his beginnings and how he got interested in food and nutrition, going into detail about his entrepreneurial journey and his hope for the future of agro-tech with our host Meghan Hendley Lopez</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;